import React from 'react';
import { Translate } from 'react-redux-i18n';
import PropTypes from 'prop-types';

/* Usage example
  <DeliveryMethodModal
    info={this.state.shipping}
  />
*/

const DeliveryMethodModal = (props) => {
  if (props.info.ShippingMethod === 'Delivery') {
    return (
      <div id="delivery-method-modal">
        <h3>
          <Translate value="time_slot" /><span className="colon">:</span>
        </h3>
        <div id="info">
          N/a
        </div>
        <h3>
          <Translate value="name" /><span className="colon">:</span>
        </h3>
        <div id="info">
          {`${props.info.FirstName} ${props.info.LastName}`}
        </div>
        <h3>
          <Translate value="address" /><span className="colon">:</span>
        </h3>
        <div id="info">
          {`${props.info.Street} ${props.info.City}, ${props.info.State} ${props.info.Zip}`}
        </div>
        <h3>
          <Translate value="phone" /><span className="colon">:</span>
        </h3>
        <div id="info">
          {props.info.Telephone}
        </div>
      </div>
    );
  } // Else props.info.ShippingMethod === 'PickUp'
  return (
    <div id="delivery-method-modal">
      <h3>
        <Translate value="time_slot" /><span className="colon">:</span>
      </h3>
      <div id="info">
        {(props.info.TimeSlot) ? props.info.TimeSlot : <Translate value="none_selected" />}
      </div>
      <h3>
        <Translate value="warehouse_name" /><span className="colon">:</span>
      </h3>
      <div id="info">
        {props.info.Name}
      </div>
      <h3>
        <Translate value="warehouse_address" /><span className="colon">:</span>
      </h3>
      <div id="info">
        {`${props.info.Street} ${props.info.City}, ${props.info.State} ${props.info.Zip}`}
      </div>
      <h3>
        <Translate value="phone" /><span className="colon">:</span>
      </h3>
      <div id="info">
        {props.info.Telephone}
      </div>
    </div>
  );
};

DeliveryMethodModal.defaultProps = {
  info: {},
};

DeliveryMethodModal.propTypes = {
  info: PropTypes.object,
};

export default DeliveryMethodModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/DeliveryMethodModal.jsx